import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {MxMaterialModule} from '../../material/mx-material.module';
import {MxButtonModule} from '../mx-button/mx-button.module';
import {MxPreloaderModule} from '../mx-preloader/mx-preloader.module';
import {MxAssignmentGridDialogComponent} from './mx-assignment-grid-dialog/mx-assignment-grid-dialog.component';


@NgModule({
    imports: [
        MxMaterialModule,
        MxButtonModule,
        MxPreloaderModule,
        CommonModule,
        TranslateModule
    ],
    exports: [
        MxAssignmentGridDialogComponent
    ],
    declarations: [
        MxAssignmentGridDialogComponent
    ]
})
export class MxAssignmentGridModule {
}
